import { makeMatchesRegex } from './general';
import { SingleValueValidator } from './types';

/**
 * Validate a string does not contain HTML tags
 */
export const doesNotContainHtml: SingleValueValidator<string> = (value) =>
    !value || !makeMatchesRegex(/<[a-z][\s\S]*>/i)(value);
